/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { slashText } from "@monsma/App/WidgetExtensions/MyListsDetails/MyListsDetailsExtension";
import { headerStyles } from "@monsma/Overrides/Widgets/MyListsDetails/MyListsDetailsHeader";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

(headerStyles as any).slashText = {
    ...slashText,
    css: css`
        ${slashText?.css};

        ${screen("lte", "sm")} {
            display: none;
        }
    `,
};

(headerStyles as any).totalTextLabel = {
    css: css`
        font-weight: normal;
    `,
};

(headerStyles as any).totalNumberOfItemsWrapper = {
    weight: "bold",
    css: css`
        display: inline-flex;
        margin-right: 40px;
        .total-label {
            font-weight: normal;
        }
    `,
};

headerStyles.container = {
    gap: 30,
};

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        align-items: flex-start;
        flex-wrap: wrap;

        @media print {
            justify-content: flex-start;
            flex-direction: row !important;
        }

        ${screen("lte", "sm")} {
            line-height: 30px;
        }
    `,
};

headerStyles.lastUpdateText = {
    css: css`
        padding-right: 40px;
    `,
};

headerStyles.sharingStatus = {
    statusText: {
        css: css`
            padding-right: 40px;
            font-size: 15px;
            font-weight: 600;
            color: ${getColor("common.ui2")};
            display: flex;
            align-items: center;

            ${IconWrapper} {
                color: ${getColor("common.ui2")};
            }
        `,
    },
    privateTooltip: {
        typographyProps: {
            color: "text.main",
        }
    }
};

headerStyles.lastUpdateText = {
    css: css`
        padding-right: 40px;
    `,
};

headerStyles.totalText = {
    weight: "bold",
    css: css`
        display: inline-flex;
    `,
};

headerStyles.descriptionGridItem = {
    width: 12,
    css: css`
        padding-top: 5px;
    `,
};

headerStyles.descriptionStyles = {
    wrapper: {
        css: css`
            display: inline-flex;
            width: 100%;

            ${screen("lte", "sm")} {
                display: block;
            }
        `,
    },
    heading: {
        css: css`
            font-size: 15px;
            text-transform: capitalize;
            margin-right: 20px;
            font-weight: normal;
            width: auto;
            flex: 0 1 auto;
            min-width: 85px;

            ${screen("lte", "sm")} {
                display: inline;
            }
        `,
    },
    text: {
        css: css`
            line-height: 26px;

            ${screen("lte", "sm")} {
                display: inline;
            }
        `,
    },
};
